import { FC } from 'react';
import {
  Dialog,
  Button,
  FormControlLabel,
  Switch,
  Typography,
  Box
} from '@mui/material';
import styles from './styles';

interface TabSettingsProps {
  open: boolean;
  mode: string;
  isFragment: boolean;
  onClose: () => void;
  onToggleMode: () => void;
  onToggleFragment: () => void;
}

export const TabSettings: FC<TabSettingsProps> = ({
  open,
  mode,
  isFragment,
  onClose,
  onToggleMode,
  onToggleFragment
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <Box sx={{ p: 24 }}>
        <Box sx={{ padding: '0' }}>
          <Typography variant="h6" sx={{ mb: 20 }}>Tab Settings</Typography>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <FormControlLabel
              label={
                <Box>
                  <Typography variant="body1" fontWeight={500}>
                    {mode === 'tab' ? 'Tab View' : 'Single View'}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Toggle between tab view and single view mode
                  </Typography>
                </Box>
              }
              control={
                <Switch
                  checked={mode === 'tab'}
                  color="secondary"
                  onChange={onToggleMode}
                />
              }
              sx={{ alignItems: 'flex-start', ml: 0 }}
            />
            
            <FormControlLabel
              label={
                <Box>
                  <Typography variant="body1" fontWeight={500}>
                    Fragment
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Enable fragment mode for this widget
                  </Typography>
                </Box>
              }
              control={
                <Switch
                  checked={isFragment}
                  color="secondary"
                  onChange={onToggleFragment}
                />
              }
              sx={{ alignItems: 'flex-start', ml: 0 }}
            />
          </Box>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 20 }}>
          <Button onClick={onClose}>Okay</Button>
        </Box>
      </Box>
    </Dialog>
  );
};

